import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import React from 'react';
import type { Route } from 'next';
interface InternalLinkProps extends React.ComponentProps<typeof Button> {
  href: Route;
}
function InternalLink(t0) {
  const $ = _c(17);
  let buttonProps;
  let children;
  let className;
  let href;
  let t1;
  if ($[0] !== t0) {
    ({
      href,
      children,
      className,
      variant: t1,
      ...buttonProps
    } = t0);
    $[0] = t0;
    $[1] = buttonProps;
    $[2] = children;
    $[3] = className;
    $[4] = href;
    $[5] = t1;
  } else {
    buttonProps = $[1];
    children = $[2];
    className = $[3];
    href = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "secondary" : t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("group/link", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRight className="size-4 transition-transform duration-200 ease-in-out group-hover/link:translate-x-1.5" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== href) {
    t4 = <Link href={href}>{children}{" "}{t3}</Link>;
    $[9] = children;
    $[10] = href;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== buttonProps || $[13] !== t2 || $[14] !== t4 || $[15] !== variant) {
    t5 = <Button variant={variant} asChild={true} className={t2} {...buttonProps}>{t4}</Button>;
    $[12] = buttonProps;
    $[13] = t2;
    $[14] = t4;
    $[15] = variant;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export { InternalLink };